export const BOOK_MEETING = "BOOK_MEETING";
export const BOOK_MEETING_SUCCESS = "BOOK_MEETING_SUCCESS";
export const BOOK_MEETING_FAILED = "BOOK_MEETING_FAILED";

export const CANCEL_MEETING_SUCCESS = "CANCEL_MEETING_SUCCESS";
export const CANCEL_MEETING_FAILED = "CANCEL_MEETING_FAILED";
